'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _DefaultString = require('../../helpers/DefaultString');

var _ProviderNotListed = require('./ProviderNotListed.scss');

var _ProviderNotListed2 = _interopRequireDefault(_ProviderNotListed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProviderNotListed = function (_Component) {
  (0, _inherits3.default)(ProviderNotListed, _Component);

  function ProviderNotListed() {
    (0, _classCallCheck3.default)(this, ProviderNotListed);
    return (0, _possibleConstructorReturn3.default)(this, (ProviderNotListed.__proto__ || (0, _getPrototypeOf2.default)(ProviderNotListed)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProviderNotListed, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _ProviderNotListed2.default.providerNotListed },
        _react2.default.createElement(
          'div',
          { className: _ProviderNotListed2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ProvidersTitle)
        ),
        _react2.default.createElement(
          'div',
          { className: _ProviderNotListed2.default.message },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ProviderNotListedTitle)
        ),
        _react2.default.createElement(
          'div',
          { className: _ProviderNotListed2.default.subMessage },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.ProviderNotListedMessage)
        )
      );
    }
  }]);
  return ProviderNotListed;
}(_react.Component);

exports.default = (0, _reactIntl.injectIntl)(ProviderNotListed);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ProviderNotListed/ProviderNotListed.js
// module id = 2014
// module chunks = 0